import { cn } from '@frontdoor/ui/lib/utils';
import { CircleAlert } from 'lucide-react';

import type { BadgeVariant } from '@/pages/track/status-config.tsx';

type StatusBadgeProps = {
  text: string;
  variant: BadgeVariant;
};

const variantStyles: Record<BadgeVariant, string> = {
  upcoming: 'bg-marigold-100 text-marigold-900',
  action: 'bg-rose-200 text-rose-700',
};

export function StatusBadge({ text, variant }: StatusBadgeProps) {
  const showIcon = variant === 'action';

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded px-1.5 py-1 text-xs font-medium',
        variantStyles[variant]
      )}
    >
      {showIcon && <CircleAlert className="size-3.5" />}
      {text}
    </span>
  );
}
